import { RealtimeInterface } from '../services/realtime/realtime-interface';
import { PlanningHasEntity } from './planning-has-entity.class';
import { ProjectComment } from './project-comment';
import { UserPlanning } from './user-planning';
import { User } from './user.class';

export class Project implements RealtimeInterface {
    afas_project_id: string;
    afas_customer_id: string;
    parent_id: string;
    parent?: Project;
    id: number;
    name: string;
    group: string;
    projectmanager_id: number;
    performer_id: number;
    performer: User;
    projectmanager: User;
    asphalt_performer_id: number;
    asphalt_performer: User;
    location: string;
    location_housenumber: string;
    location_place: string;
    location_postcode: string;
    location_straat: string;
    contractor: string;
    begindate: Date;
    enddate: Date;
    created_at: Date;
    updated_at: Date;

    status: number;
    status_name: string;

    user_planning: UserPlanning[];
    planning_has: PlanningHasEntity[];
    project_comments: ProjectComment[];
    realisation_times?: {
        week: number;
        year: number;
        user_minutes: number;
        entity_minutes: number;
    }[];

    mainProject?: string;
    projects?: Project[];

    week_numbers?: string;
}

export enum ProjectStatus {
    Hoofdproject = 0,
    Offerte = 1,
    Opdracht = 2,
    TechnGereed = 3,
    FinGereed = 4,
    Vervallen = 5,
    Afgesloten2023 = 823,
    Afgesloten2024 = 824,
    Afgesloten2025 = 825,
    Afgemeld = 900,
}
